import type { BankTransferView } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { formatDateTime } from '@/shared/lib';
import { Button, detailListStyles as styles } from '@/shared/ui';

interface Props {
  readonly transfer: BankTransferView;
  readonly canConfirm: boolean;
  readonly canRefund: boolean;
  readonly onConfirm: () => void;
  readonly onRefund: () => void;
}
export function OrderBankTransferInfo({
  transfer,
  canConfirm,
  canRefund,
  onConfirm,
  onRefund,
}: Props): ReactElement {
  return (
    <div className="mt-4 flex flex-col gap-3">
      <dl className={styles.list}>
        <dt className={styles.term}>입금자명</dt>
        <dd>{transfer.depositorName}</dd>
        <dt className={styles.term}>입금 기한</dt>
        <dd>{formatDateTime(transfer.dueAt)}</dd>
        {transfer.depositedOn && (
          <>
            <dt className={styles.term}>입금일</dt>
            <dd>{transfer.depositedOn}</dd>
          </>
        )}
        {(transfer.status === 'REFUND_PENDING' || transfer.status === 'CANCELED') && (
          <>
            <dt className={styles.term}>환불 상태</dt>
            <dd>{transfer.status === 'CANCELED' ? '환불 완료' : '환불 대기'}</dd>
            <dt className={styles.term}>환불 계좌</dt>
            <dd>
              {transfer.refundAccount
                ? `${transfer.refundAccount.bank} ${transfer.refundAccount.account} ${transfer.refundAccount.holder}`
                : '미입력'}
            </dd>
            {transfer.refundedOn && (
              <>
                <dt className={styles.term}>환불일</dt>
                <dd>{transfer.refundedOn}</dd>
              </>
            )}
          </>
        )}
      </dl>
      {canConfirm && <Button onClick={onConfirm}>입금 확인</Button>}
      {canRefund && <Button onClick={onRefund}>환불 완료</Button>}
    </div>
  );
}
